import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { CandidatesView } from 'src/sections/cheque-factoring/view';

export default function FactoringCandidatesPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Factoring Candidates</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_FACTORING_CANDIDATES,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <CandidatesView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
